export default "__VITE_ASSET__DJ69bUcg__";